var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.075 18.925C4.80834 18.6584 4.675 18.35 4.675 18C4.675 17.65 4.80834 17.3417 5.075 17.075L17.075 5.07505C17.325 4.80838 17.6292 4.67505 17.9875 4.67505C18.3458 4.67505 18.6583 4.80838 18.925 5.07505C19.1917 5.34172 19.325 5.65005 19.325 6.00005C19.325 6.35005 19.1917 6.65838 18.925 6.92505L6.925 18.925C6.65834 19.1917 6.35 19.325 6 19.325C5.65 19.325 5.34167 19.1917 5.075 18.925Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLine);
export default __webpack_public_path__ + "static/media/ico-line.04ef7fcd864c0c178b3fb4024cb95cf7.svg";
export { ForwardRef as ReactComponent };